export default __webpack_public_path__ + "static/media/slide_investigacion.1c3b9fee.png";